import { store } from 'app/redux/store';
import { BusinessProjectGetId } from 'app/services/responseTypes';
import { updateKey } from '../edit/TaxQuestionnaire/BusinessInfo/BusinessType/slice';

export default function autoFillBusinessTypeSlice(
  business: BusinessProjectGetId,
) {
  const { business_type } = business;

  store.dispatch(updateKey({ key: 'businessType', value: business_type }));
}
